/**
 * Adyen wallet-load RUM reasons. When the SDK rejects, we forward the raw
 * `name` / `message` / `cause` chain. These tokens are only for paths with
 * no Adyen error object.
 */
export const WALLET_AVAILABILITY_REASON = {
  METHOD_NOT_OFFERED: 'method_not_offered',
  TIMEOUT: 'timeout',
  UNKNOWN: 'unknown',
} as const;

export const EXPRESS_WALLET_NAME = {
  APPLE_PAY: 'apple_pay',
  GOOGLE_PAY: 'google_pay',
} as const;

const collectErrorText = (error: unknown, seen = new WeakSet<object>()): string => {
  if (error == null) return '';
  if (typeof error === 'string') return error;
  if (typeof error !== 'object') return String(error);
  if (seen.has(error)) return '';
  seen.add(error);

  const { name, message, cause } = error as { name?: unknown; message?: unknown; cause?: unknown };
  return [name, message, collectErrorText(cause, seen)].filter(Boolean).join(' ');
};

/** Raw Adyen/SDK error text for RUM. Never throws. */
export const formatAdyenWalletAvailabilityReason = (error: unknown): string => {
  try {
    return collectErrorText(error).trim() || WALLET_AVAILABILITY_REASON.UNKNOWN;
  } catch {
    return WALLET_AVAILABILITY_REASON.UNKNOWN;
  }
};
